import { api, authorizedFetch } from '@/shared/api/api-client';
import { ENDPOINTS } from '@/shared/api/endpoints';
import type {
  CandidateImageKind,
  CandidateImagesMetadata,
} from '../models/candidate-images.types';

const BASE = ENDPOINTS.candidates.me.images;

export function getCandidateImagesMetadata(): Promise<CandidateImagesMetadata> {
  return api().get<CandidateImagesMetadata>(BASE);
}

export function uploadCandidateImage(
  kind: CandidateImageKind,
  file: File,
): Promise<CandidateImagesMetadata> {
  const body = new FormData();
  body.append('file', file);
  return api().put<CandidateImagesMetadata>(`${BASE}/${kind}`, body);
}

export function deleteCandidateImage(
  kind: CandidateImageKind,
): Promise<CandidateImagesMetadata> {
  return api().delete<CandidateImagesMetadata>(`${BASE}/${kind}`);
}

/**
 * Fetch the stored image bytes (served raw, not JSON-wrapped) as an object URL
 * the caller can use as an <img src>. Returns null when no image exists (404)
 * or the fetch fails. The caller owns revoking the URL.
 */
export async function fetchCandidateImageObjectUrl(
  kind: CandidateImageKind,
): Promise<string | null> {
  const response = await authorizedFetch(`${BASE}/${kind}`);
  if (!response.ok) {
    return null;
  }
  const blob = await response.blob();
  return URL.createObjectURL(blob);
}
